module.exports = __webpack_public_path__ + "static/vib_play7-2bb3d577180e3f7e660fc95f5f9586ad.jpg";